export default "__VITE_ASSET__3d25504a__"